/**
 * The wire shapes `Rws.AiInsights.Host.Reporting.ModelNameAdminEndpoints` returns (`AIA-81`): every model
 * name with recorded spend, beside the display name it is grouped and labelled by. Gated on `settings.write`.
 * A model with no display name yet is shown under its raw name, and listed here as unmapped.
 */
import { adminRequest, type AdminResult } from "./adminApi";

/** One vendor's raw model name, its all-time gross spend in US dollars, and its saved display name. */
export interface ModelNameEntry {
  vendorId: string;
  rawName: string;
  grossSpendUsd: number;
  displayName: string | null;
}

/** One requested display-name change. A null display name clears the mapping. */
export interface ModelNameChange {
  vendorId: string;
  rawName: string;
  displayName: string | null;
}

const modelNamesPath = "/api/reporting/model-names";

/** Calls `GET /api/reporting/model-names`. */
export async function fetchModelNames(): Promise<AdminResult<ModelNameEntry[]>> {
  return adminRequest<ModelNameEntry[]>(modelNamesPath, { method: "GET" }, "model names");
}

/** Calls `PUT /api/reporting/model-names` with every requested change, and answers with the full list after the save. */
export async function saveModelNames(changes: ModelNameChange[]): Promise<AdminResult<ModelNameEntry[]>> {
  return adminRequest<ModelNameEntry[]>(modelNamesPath, { method: "PUT", body: JSON.stringify(changes) }, "model name changes");
}
